export default "__VITE_ASSET__DaIvST2u__"